export const LeftNavigationInjects: any[] = [];
